import React, { SVGProps } from "react";

export default function SupDustShowing(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M16.3421 8.98487C16.9139 8.2093 17.0078 7.13777 16.4952 6.24996C15.9826 5.36214 15.0077 4.90766 14.0502 5.01504L13.7815 4.54972C14.9965 4.32378 16.2751 4.86874 16.9282 5.99996C17.5813 7.13117 17.414 8.51094 16.6108 9.4502L16.3421 8.98487Z"
        fill="currentColor"
      />
      <path
        d="M14.0502 14.9849C15.0078 15.0922 15.9827 14.6378 16.4952 13.75C17.0078 12.8621 16.914 11.7906 16.3422 11.015L16.6108 10.5497C17.414 11.489 17.5814 12.8687 16.9282 14C16.2751 15.1312 14.9966 15.6761 13.7816 15.4502L14.0502 14.9849Z"
        fill="currentColor"
      />
      <path
        d="M7.70807 16C8.09385 16.883 8.97489 17.5 10.0001 17.5C11.0252 17.5 11.9063 16.883 12.292 16H12.8293C12.4175 17.1652 11.3063 18 10.0001 18C8.69383 18 7.58259 17.1652 7.17076 16H7.70807Z"
        fill="currentColor"
      />
      <path
        d="M3.65786 11.0151C3.08609 11.7907 2.99224 12.8622 3.50482 13.75C4.0174 14.6379 4.99229 15.0923 5.94984 14.985L6.2185 15.4503C5.0035 15.6762 3.72491 15.1313 3.0718 14C2.41869 12.8688 2.58604 11.4891 3.38921 10.5498L3.65786 11.0151Z"
        fill="currentColor"
      />
      <path
        d="M5.94979 5.01513C4.99224 4.90775 4.01734 5.36223 3.50476 6.25005C2.99218 7.13786 3.08604 8.20939 3.65781 8.98496L3.38916 9.45029C2.58599 8.51103 2.41864 7.13126 3.07175 6.00005C3.72486 4.86883 5.00345 4.32387 6.21845 4.5498L5.94979 5.01513Z"
        fill="currentColor"
      />
      <path
        d="M12.2919 4C11.9061 3.11705 11.0251 2.5 9.99995 2.5C8.97479 2.5 8.09375 3.11705 7.70797 4H7.17065C7.58249 2.83481 8.69373 2 9.99995 2C11.3062 2 12.4174 2.83481 12.8292 4H12.2919Z"
        fill="currentColor"
      />
      <path
        d="M7.76777 7.64645L8.12132 7.29289C7.7308 6.90237 7.09763 6.90237 6.70711 7.29289C6.31658 7.68342 6.31658 8.31658 6.70711 8.70711L7.06066 8.35355C6.8654 8.15829 6.8654 7.84171 7.06066 7.64645C7.25592 7.45118 7.5725 7.45118 7.76777 7.64645Z"
        fill="currentColor"
      />
      <path
        d="M12.2322 7.64645L11.8787 7.29289C12.2692 6.90237 12.9024 6.90237 13.2929 7.29289C13.6834 7.68342 13.6834 8.31658 13.2929 8.70711L12.9393 8.35355C13.1346 8.15829 13.1346 7.84171 12.9393 7.64645C12.7441 7.45118 12.4275 7.45118 12.2322 7.64645Z"
        fill="currentColor"
      />
      <path
        d="M10.532 6.17322C10.9233 6.04479 11.3655 6.07711 11.7503 6.29923C12.135 6.52136 12.3841 6.88818 12.4685 7.29127L13.0006 7.59846C13 6.90785 12.6414 6.23636 12.0003 5.86622C11.3592 5.49608 10.5983 5.52122 9.99994 5.86603L10.532 6.17322Z"
        fill="currentColor"
      />
      <path
        d="M12.2322 13.0607L11.8787 13.4142C12.2692 13.8047 12.9024 13.8047 13.2929 13.4142C13.6834 13.0237 13.6834 12.3905 13.2929 12L12.9393 12.3536C13.1346 12.5488 13.1346 12.8654 12.9393 13.0607C12.7441 13.2559 12.4275 13.2559 12.2322 13.0607Z"
        fill="currentColor"
      />
      <path
        d="M7.76777 13.0607L8.12132 13.4142C7.7308 13.8047 7.09763 13.8047 6.70711 13.4142C6.31658 13.0237 6.31658 12.3905 6.70711 12L7.06066 12.3536C6.8654 12.5488 6.8654 12.8654 7.06066 13.0607C7.25592 13.2559 7.5725 13.2559 7.76777 13.0607Z"
        fill="currentColor"
      />
      <path
        d="M9.46799 14.5339C9.07669 14.6623 8.63445 14.63 8.24972 14.4079C7.86499 14.1858 7.61589 13.8189 7.53146 13.4158L6.99939 13.1086C6.99997 13.7993 7.35862 14.4707 7.99972 14.8409C8.64083 15.211 9.40168 15.1859 10.0001 14.8411L9.46799 14.5339Z"
        fill="currentColor"
      />
      <path
        d="M14.7991 4.68792C14.5942 4.20709 14.2374 3.78624 13.7499 3.50478C13.2624 3.22333 12.7195 3.12472 12.2006 3.18767L11.5634 2.81974C12.346 2.56288 13.2304 2.62752 13.9999 3.07177C14.7693 3.51602 15.2676 4.24967 15.4364 5.05585L14.7991 4.68792Z"
        fill="currentColor"
      />
      <path
        d="M17 11.5002C17.314 11.0823 17.5 10.5629 17.5 9.99995C17.5 9.43704 17.314 8.91758 17 8.4997V7.76384C17.6137 8.31316 18 9.11145 18 9.99995C18 10.8884 17.6137 11.6867 17 12.2361V11.5002Z"
        fill="currentColor"
      />
      <path
        d="M12.2009 16.8123C12.7197 16.8752 13.2626 16.7766 13.7501 16.4952C14.2376 16.2137 14.5945 15.7929 14.7994 15.312L15.4366 14.9441C15.2678 15.7503 14.7696 16.4839 14.0001 16.9282C13.2307 17.3724 12.3462 17.4371 11.5636 17.1802L12.2009 16.8123Z"
        fill="currentColor"
      />
      <path
        d="M5.20087 15.3121C5.40578 15.7929 5.76262 16.2138 6.25012 16.4952C6.73762 16.7767 7.2805 16.8753 7.79937 16.8123L8.43665 17.1803C7.65405 17.4371 6.76958 17.3725 6.00012 16.9282C5.23066 16.484 4.73245 15.7503 4.5636 14.9441L5.20087 15.3121Z"
        fill="currentColor"
      />
      <path
        d="M3 8.49981C2.68604 8.91768 2.5 9.43714 2.5 10.0001C2.5 10.563 2.68604 11.0824 3 11.5003V12.2362C2.38625 11.6868 2 10.8886 2 10.0001C2 9.11155 2.38625 8.31327 3 7.76395V8.49981Z"
        fill="currentColor"
      />
      <path
        d="M7.79913 3.18772C7.28026 3.12477 6.73738 3.22338 6.24988 3.50483C5.76238 3.78629 5.40554 4.20714 5.20063 4.68797L4.56335 5.0559C4.73221 4.24972 5.23042 3.51607 5.99988 3.07182C6.76934 2.62757 7.6538 2.56293 8.4364 2.81979L7.79913 3.18772Z"
        fill="currentColor"
      />
      <path d="M18 4.5C18 4.77614 17.7761 5 17.5 5C17.2239 5 17 4.77614 17 4.5C17 4.22386 17.2239 4 17.5 4C17.7761 4 18 4.22386 18 4.5Z" fill="currentColor" />
      <path d="M18 16.5C18 16.7761 17.7761 17 17.5 17C17.2239 17 17 16.7761 17 16.5C17 16.2239 17.2239 16 17.5 16C17.7761 16 18 16.2239 18 16.5Z" fill="currentColor" />
      <path d="M3 17.5C3 17.7761 2.77614 18 2.5 18C2.22386 18 2 17.7761 2 17.5C2 17.2239 2.22386 17 2.5 17C2.77614 17 3 17.2239 3 17.5Z" fill="currentColor" />
      <path d="M12.5 11C12.5 12.1046 11.1046 13 10 13C8.89543 13 7.5 12.1046 7.5 11C7.5 9.89543 8.89543 10.5 10 10.5C11.1046 10.5 12.5 9.89543 12.5 11Z" fill="currentColor" />
      <path d="M9 8.5C9 8.77614 8.77614 9 8.5 9C8.22386 9 8 8.77614 8 8.5C8 8.22386 8.22386 8 8.5 8C8.77614 8 9 8.22386 9 8.5Z" fill="currentColor" />
      <path d="M12 8.5C12 8.77614 11.7761 9 11.5 9C11.2239 9 11 8.77614 11 8.5C11 8.22386 11.2239 8 11.5 8C11.7761 8 12 8.22386 12 8.5Z" fill="currentColor" />
      <path d="M5 2.5C5 2.77614 4.77614 3 4.5 3C4.22386 3 4 2.77614 4 2.5C4 2.22386 4.22386 2 4.5 2C4.77614 2 5 2.22386 5 2.5Z" fill="currentColor" />
      <path
        d="M16.3421 8.98487C16.9139 8.2093 17.0078 7.13777 16.4952 6.24996C15.9826 5.36214 15.0077 4.90766 14.0502 5.01504L13.7815 4.54972C14.9965 4.32378 16.2751 4.86874 16.9282 5.99996C17.5813 7.13117 17.414 8.51094 16.6108 9.4502L16.3421 8.98487Z"
        stroke="currentColor"
        strokeWidth="0.3"
      />
      <path
        d="M14.0502 14.9849C15.0078 15.0922 15.9827 14.6378 16.4952 13.75C17.0078 12.8621 16.914 11.7906 16.3422 11.015L16.6108 10.5497C17.414 11.489 17.5814 12.8687 16.9282 14C16.2751 15.1312 14.9966 15.6761 13.7816 15.4502L14.0502 14.9849Z"
        stroke="currentColor"
        strokeWidth="0.3"
      />
      <path
        d="M7.70807 16C8.09385 16.883 8.97489 17.5 10.0001 17.5C11.0252 17.5 11.9063 16.883 12.292 16H12.8293C12.4175 17.1652 11.3063 18 10.0001 18C8.69383 18 7.58259 17.1652 7.17076 16H7.70807Z"
        stroke="currentColor"
        strokeWidth="0.3"
      />
      <path
        d="M3.65786 11.0151C3.08609 11.7907 2.99224 12.8622 3.50482 13.75C4.0174 14.6379 4.99229 15.0923 5.94984 14.985L6.2185 15.4503C5.0035 15.6762 3.72491 15.1313 3.0718 14C2.41869 12.8688 2.58604 11.4891 3.38921 10.5498L3.65786 11.0151Z"
        stroke="currentColor"
        strokeWidth="0.3"
      />
      <path
        d="M5.94979 5.01513C4.99224 4.90775 4.01734 5.36223 3.50476 6.25005C2.99218 7.13786 3.08604 8.20939 3.65781 8.98496L3.38916 9.45029C2.58599 8.51103 2.41864 7.13126 3.07175 6.00005C3.72486 4.86883 5.00345 4.32387 6.21845 4.5498L5.94979 5.01513Z"
        stroke="currentColor"
        strokeWidth="0.3"
      />
      <path
        d="M12.2919 4C11.9061 3.11705 11.0251 2.5 9.99995 2.5C8.97479 2.5 8.09375 3.11705 7.70797 4H7.17065C7.58249 2.83481 8.69373 2 9.99995 2C11.3062 2 12.4174 2.83481 12.8292 4H12.2919Z"
        stroke="currentColor"
        strokeWidth="0.3"
      />
      <path
        d="M7.76777 7.64645L8.12132 7.29289C7.7308 6.90237 7.09763 6.90237 6.70711 7.29289C6.31658 7.68342 6.31658 8.31658 6.70711 8.70711L7.06066 8.35355C6.8654 8.15829 6.8654 7.84171 7.06066 7.64645C7.25592 7.45118 7.5725 7.45118 7.76777 7.64645Z"
        stroke="currentColor"
        strokeWidth="0.3"
      />
      <path
        d="M12.2322 7.64645L11.8787 7.29289C12.2692 6.90237 12.9024 6.90237 13.2929 7.29289C13.6834 7.68342 13.6834 8.31658 13.2929 8.70711L12.9393 8.35355C13.1346 8.15829 13.1346 7.84171 12.9393 7.64645C12.7441 7.45118 12.4275 7.45118 12.2322 7.64645Z"
        stroke="currentColor"
        strokeWidth="0.3"
      />
      <path
        d="M10.532 6.17322C10.9233 6.04479 11.3655 6.07711 11.7503 6.29923C12.135 6.52136 12.3841 6.88818 12.4685 7.29127L13.0006 7.59846C13 6.90785 12.6414 6.23636 12.0003 5.86622C11.3592 5.49608 10.5983 5.52122 9.99994 5.86603L10.532 6.17322Z"
        stroke="currentColor"
        strokeWidth="0.3"
      />
      <path
        d="M12.2322 13.0607L11.8787 13.4142C12.2692 13.8047 12.9024 13.8047 13.2929 13.4142C13.6834 13.0237 13.6834 12.3905 13.2929 12L12.9393 12.3536C13.1346 12.5488 13.1346 12.8654 12.9393 13.0607C12.7441 13.2559 12.4275 13.2559 12.2322 13.0607Z"
        stroke="currentColor"
        strokeWidth="0.3"
      />
      <path
        d="M7.76777 13.0607L8.12132 13.4142C7.7308 13.8047 7.09763 13.8047 6.70711 13.4142C6.31658 13.0237 6.31658 12.3905 6.70711 12L7.06066 12.3536C6.8654 12.5488 6.8654 12.8654 7.06066 13.0607C7.25592 13.2559 7.5725 13.2559 7.76777 13.0607Z"
        stroke="currentColor"
        strokeWidth="0.3"
      />
      <path
        d="M9.46799 14.5339C9.07669 14.6623 8.63445 14.63 8.24972 14.4079C7.86499 14.1858 7.61589 13.8189 7.53146 13.4158L6.99939 13.1086C6.99997 13.7993 7.35862 14.4707 7.99972 14.8409C8.64083 15.211 9.40168 15.1859 10.0001 14.8411L9.46799 14.5339Z"
        stroke="currentColor"
        strokeWidth="0.3"
      />
      <path
        d="M14.7991 4.68792C14.5942 4.20709 14.2374 3.78624 13.7499 3.50478C13.2624 3.22333 12.7195 3.12472 12.2006 3.18767L11.5634 2.81974C12.346 2.56288 13.2304 2.62752 13.9999 3.07177C14.7693 3.51602 15.2676 4.24967 15.4364 5.05585L14.7991 4.68792Z"
        stroke="currentColor"
        strokeWidth="0.3"
      />
      <path
        d="M17 11.5002C17.314 11.0823 17.5 10.5629 17.5 9.99995C17.5 9.43704 17.314 8.91758 17 8.4997V7.76384C17.6137 8.31316 18 9.11145 18 9.99995C18 10.8884 17.6137 11.6867 17 12.2361V11.5002Z"
        stroke="currentColor"
        strokeWidth="0.3"
      />
      <path
        d="M12.2009 16.8123C12.7197 16.8752 13.2626 16.7766 13.7501 16.4952C14.2376 16.2137 14.5945 15.7929 14.7994 15.312L15.4366 14.9441C15.2678 15.7503 14.7696 16.4839 14.0001 16.9282C13.2307 17.3724 12.3462 17.4371 11.5636 17.1802L12.2009 16.8123Z"
        stroke="currentColor"
        strokeWidth="0.3"
      />
      <path
        d="M5.20087 15.3121C5.40578 15.7929 5.76262 16.2138 6.25012 16.4952C6.73762 16.7767 7.2805 16.8753 7.79937 16.8123L8.43665 17.1803C7.65405 17.4371 6.76958 17.3725 6.00012 16.9282C5.23066 16.484 4.73245 15.7503 4.5636 14.9441L5.20087 15.3121Z"
        stroke="currentColor"
        strokeWidth="0.3"
      />
      <path
        d="M3 8.49981C2.68604 8.91768 2.5 9.43714 2.5 10.0001C2.5 10.563 2.68604 11.0824 3 11.5003V12.2362C2.38625 11.6868 2 10.8886 2 10.0001C2 9.11155 2.38625 8.31327 3 7.76395V8.49981Z"
        stroke="currentColor"
        strokeWidth="0.3"
      />
      <path
        d="M7.79913 3.18772C7.28026 3.12477 6.73738 3.22338 6.24988 3.50483C5.76238 3.78629 5.40554 4.20714 5.20063 4.68797L4.56335 5.0559C4.73221 4.24972 5.23042 3.51607 5.99988 3.07182C6.76934 2.62757 7.6538 2.56293 8.4364 2.81979L7.79913 3.18772Z"
        stroke="currentColor"
        strokeWidth="0.3"
      />
      <path d="M18 4.5C18 4.77614 17.7761 5 17.5 5C17.2239 5 17 4.77614 17 4.5C17 4.22386 17.2239 4 17.5 4C17.7761 4 18 4.22386 18 4.5Z" stroke="currentColor" strokeWidth="0.3" />
      <path
        d="M18 16.5C18 16.7761 17.7761 17 17.5 17C17.2239 17 17 16.7761 17 16.5C17 16.2239 17.2239 16 17.5 16C17.7761 16 18 16.2239 18 16.5Z"
        stroke="currentColor"
        strokeWidth="0.3"
      />
      <path d="M3 17.5C3 17.7761 2.77614 18 2.5 18C2.22386 18 2 17.7761 2 17.5C2 17.2239 2.22386 17 2.5 17C2.77614 17 3 17.2239 3 17.5Z" stroke="currentColor" strokeWidth="0.3" />
      <path
        d="M12.5 11C12.5 12.1046 11.1046 13 10 13C8.89543 13 7.5 12.1046 7.5 11C7.5 9.89543 8.89543 10.5 10 10.5C11.1046 10.5 12.5 9.89543 12.5 11Z"
        stroke="currentColor"
        strokeWidth="0.3"
      />
      <path d="M9 8.5C9 8.77614 8.77614 9 8.5 9C8.22386 9 8 8.77614 8 8.5C8 8.22386 8.22386 8 8.5 8C8.77614 8 9 8.22386 9 8.5Z" stroke="currentColor" strokeWidth="0.3" />
      <path d="M12 8.5C12 8.77614 11.7761 9 11.5 9C11.2239 9 11 8.77614 11 8.5C11 8.22386 11.2239 8 11.5 8C11.7761 8 12 8.22386 12 8.5Z" stroke="currentColor" strokeWidth="0.3" />
      <path d="M5 2.5C5 2.77614 4.77614 3 4.5 3C4.22386 3 4 2.77614 4 2.5C4 2.22386 4.22386 2 4.5 2C4.77614 2 5 2.22386 5 2.5Z" stroke="currentColor" strokeWidth="0.3" />
    </svg>
  );
}
